export const getAccuracyLogoUrl = (name: number | string) => {
    return `${process.env.PUBLIC_URL}/assets/images/tournament_accuracy/${name}.svg`;
};
